export function scoreJobForUser(job, resume) {
	let score = 0;
	const skills = new Set(
		(resume?.sections?.skills || []).flatMap((c) => c.items || []).map((s) => String(s).toLowerCase())
	);
	const title = String(job.title || '').toLowerCase();
	const positionSkills = Array.from(skills).filter((s) => title.includes(s));
	score += Math.min(30, positionSkills.length * 5);
	const reqs = (job.requirements || []).map((r) => String(r).toLowerCase());
	for (const r of reqs) {
		for (const s of skills) {
			if (r.includes(s)) {
				score += 2;
			}
		}
	}
	if (job.experienceLevel && String(job.experienceLevel).toLowerCase().includes('mid')) score += 5;
	if (job.locationType === 'remote') score += 3;
	return Math.min(100, score);
}

export function recommendJobs(jobs = [], resume) {
	const scored = jobs.map((j) => ({ job: j, score: scoreJobForUser(j, resume) }));
	scored.sort((a, b) => b.score - a.score);
	return scored.map((s) => ({ ...s.job, matchScore: s.score }));
}


